<div class="border-bottom">
    <h6 class="fw-bold">Selected Preferences</h6>
</div>

<div *ngIf="preferences" class="table-responsive">
    <table class="table align-items-center table-hover table-sm">
        <colgroup>
            <col style="width: 10%">
            <col style="width: 30%">
            <col style="width: 30%">
            <col style="width: 10%">
            <col style="width: 10%">
            <col style="width: 10%">
        </colgroup>
        <thead class="table-info">
            <tr>
                <th *ngFor="let c of columns">
                    <div *ngIf="c.isSortable">
                        <div class="d-flex justify-content-between align-items-center">
                            {{ c.title }}
                        </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                        {{ c.title }}
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let v of preferences; let i=index;">
                <td>{{ v.order }}</td>
                <td>{{ v.vacantPost?.sanctionedPost?.school?.name }}</td>
                <td>{{ v.vacantPost.vacancyType?.name }}</td>
                <td>
                    <button [disabled]="i==0" type="button" class="btn btn-success btn-sm" (click)="up(v)">
                        <i-bs name="caret-up-fill" width="1em" height="1em"></i-bs>
                    </button>
                </td>
                <td>
                    <button [disabled]="(i + 1) ==  preferences.length" type="button" class="btn btn-success btn-sm"
                        (click)="down(v)">
                        <i-bs name="caret-down-fill" width="1em" height="1em"></i-bs>
                    </button>
                </td>
                <td>
                    <button type="button" class="btn btn-danger btn-sm" (click)="delete(v)">
                        <i-bs name="trash" width="1em" height="1em"></i-bs>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>